import React from 'react';
import styled from 'styled-components';

import { RichTextInput } from '../TextInput';
import AttachmentIcon from './AttachmentVertical';
import SmileIcon from './Smile';
import SendIcon from './Send';

export const AddCommentContainer = styled('div')`
  display: grid;
  align-items: center;
  justify-items: end;
`;

export const StyledTextInput = styled(RichTextInput)`
  > p {
    font-size: 16px;
    padding: 10px;
    padding-right: 110px;
    max-height: 300px;
    overflow: overlay;
  }
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
`;

export const StyledSmileIcon = styled(SmileIcon)`
  color: black;
  opacity: 0.6;
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    opacity: 1;
  }
`;

export const StyledAttachmentIcon = styled(AttachmentIcon)`
  color: black;
  opacity: 0.6;
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    opacity: 1;
  }
`;

export const StyledSendIcon = styled(SendIcon)<{ disabled: boolean }>`
  transition: all 0.2s ease-in-out;
  color: ${({ disabled }) => (disabled ? 'rgba(0, 0, 0, 0.45)' : 'rgba(7, 114, 229, 0.8)')};

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    filter: drop-shadow(2px 2px 2px ${({ theme }) => theme.palette.primary.main});
  }
`;

export const ContainerAttachment = styled('div')`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 1;
  grid-row-end: 1;
`;

export const MentionText = styled('b')`
  font: 14px/20px Roboto;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;
  margin: 0;
`;

export const IconsContainer = styled('div')`
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 1;
  grid-row-end: 1;
  z-index: 1;
  gap: 10px;
  display: flex;
  margin-right: 10px;
  flex: 1;
  align-items: flex-end;
  height: 100%;
  margin-bottom: 20px;
`;
